// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"25":"ui/main/css/main","627":"ui/main/css/product_page","794":"ui/main/css/homepage","993":"ui/main/css/pd_blog"}[chunkId] + ".css";
};